module.exports = __webpack_public_path__ + "img/img-71.90577595.png";